export default "/images/vendor/flag-icon-css/flags/4x3/jo.svg?f41fe7d26b69dec06fef1fb61a0e0fff";